import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vehicle-list-loading',
  templateUrl: './vehicle-list-loading.component.html',
  styleUrls: ['./vehicle-list-loading.component.scss']
})
export class VehicleListLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
